import "../../View/OthersPages/OthersPages.css"
import SeoGeneral from '../BusinessPage/SeoGeneral';

function LetsgetinTouch() {

    const seoMetaData = {
        title: "Contact NeooSearch – We're Here to Help!",
        description: "Get in touch with NeooSearch for any questions or assistance. Reach out via email, phone, or our contact form. We're eager to assist you.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "Contact NeooSearch – We're Here to Help!",
        url: process.env.REACT_APP_APPLICATION_URL + "/lets-get-intouch",
        keywords: "NeooSearch, contact us, lets-get-intouch, customer support, assistance, email, phone, contact form",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/lets-get-intouch"
    };

    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <section className='letsgetinTouch_sec'>
                <div className='cust_container'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-12'>
                            <h4 className='heading'>Lets Get in <span>Touch!</span></h4>
                            <p className='text'>Have a question or need assistance? Reach out to us via email, </p>
                            <p className='text'>phone, or the contact form below. We're eager to assist you.</p>

                            <h6 className='colortext'>Nice hearing from you!</h6>

                            {/* <div>
                                <h3 className='subheading'>Head Office:</h3>
                                <ul>
                                    <li className="text"><i className="fa-solid fa-phone"></i> <span>+971 554799121</span></li>
                                    <li className="text"><i className="fa-solid fa-envelope"></i><span>neoosearch@gmail.com</span></li>
                                    <li className="text"><i className="fa-solid fa-location-dot"></i><span>Business Center,Sharjah Publishing City Free ZoneSharjah, United Arab Emirates</span></li>
                                </ul>
                            </div> */}

                            {/* <div>
                                <h3 className='subheading'>Branch Office:</h3>
                                <ul>
                                    <li className="text"><i className="fa-solid fa-phone"></i> <span>+971 554799121</span></li>
                                    <li className="text"><i className="fa-solid fa-envelope"></i><span>info@neoosearch.com</span></li>
                                    <li className="text"><i className="fa-solid fa-location-dot"></i><span>Business Center,Sharjah Publishing City Free ZoneSharjah, United Arab Emirates</span></li>
                                </ul>
                            </div> */}

                            <div>
                                <h3 className='subheading'>Neoo Search FZE</h3>
                                <ul>
                                    <li className="text"><i className="fa-solid fa-location-dot"></i><span>SRTI Park, Sharjah - United Arab Emirates</span></li>
                                    <li className="text"><i className="fa-solid fa-envelope"></i><span>info@neoosearch.com</span></li>
                                    <li className="text"><i className="fa-solid fa-phone"></i> <span>+971 55 479 9121</span></li>
                                </ul>
                            </div>

                        </div>
                        <div className='col-lg-6 col-md-6 col-12 mt-4'>
                            <div className='letsgetinTouch_form'>
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="">Full Name:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id=""
                                            aria-describedby=""
                                            placeholder=""
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="">Company name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id=""
                                            placeholder=""
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="">Contact number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id=""
                                            placeholder=""
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="">Email:</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id=""
                                            placeholder=""
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Message:</label>
                                        <textarea
                                            className="form-control"
                                            id=""
                                            rows={4}
                                            defaultValue={""}
                                        />
                                    </div>

                                    <div className='Submit_btn'>
                                        <button type="submit" className="btn">Submit</button>
                                    </div>

                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </section >

        </>
    )
}

export default LetsgetinTouch